export class MandatoryMap<K, V> {
	constructor(
		private map: Map<K, V>,
		private entityName: string
	) {
	}
	
	get(key: K): V {
		let value = this.map.get(key);
		if (!value)
			throw new Error(this.entityName + " #" + key + " introuvable");
		return value;
	}
	
	isEmpty(): boolean {
		return this.map === null || this.map.size === 0;
	}
}
